(function () {
	const tickSlider = () => {
		$(".ticker").each(function () {
			const $this = $(this);
			const el = this;
			if (el._tickerRevolutionTimer) {
				clearInterval(el._tickerRevolutionTimer);
				el._tickerRevolutionTimer = null;
			}
			const id = $this.attr("id");
			const tickerId = $this.data("ticker-id");
			const tickerSpeedSec = $this.data("ticker-speed");
			const tickerSpeed = tickerSpeedSec * 1000;
			const switchSec = $this.data("ticker-switch-seconds");
			const switchIntervalMs = (switchSec != null && switchSec > 0 ? switchSec : 5) * 1000;
			const phrasesRaw = $this.data("ticker-phrases");
			const phrases = typeof phrasesRaw === "string" && phrasesRaw.length
				? phrasesRaw.split("|||").map(function (s) { return s.trim(); }).filter(Boolean)
				: [];

			const initSwiper = function () {
				return new Swiper(`#${id} .ticker-js-${tickerId}`, {
					slidesPerView: "auto",
					speed: tickerSpeed,
					initialSlide: 0,
					loop: true,
					allowTouchMove: false,
					waitForTransition: false,
					watchSlidesProgress: false,
					autoplay: {
						delay: 0,
						disableOnInteraction: false,
					},
				});
			};

			if (phrases.length <= 1) {
				initSwiper();
				return;
			}

			let currentIndex = 0;
			let swiperInstance = initSwiper();
			const $wrapper = $this.find(".swiper-wrapper");
			const $slides = $wrapper.find(".swiper-slide");

			const setPhrase = function (phrase) {
				$slides.find(".ticker__title").text(phrase);
			};

			const nextPhrase = function () {
				currentIndex = (currentIndex + 1) % phrases.length;
				setPhrase(phrases[currentIndex]);
				if (swiperInstance && swiperInstance.destroy) {
					swiperInstance.destroy(true, false);
				}
				swiperInstance = initSwiper();
			};

			el._tickerRevolutionTimer = setInterval(function () {
				nextPhrase();
			}, switchIntervalMs);
		});
	};

	document.addEventListener("shopify:section:load", function () {
		setTimeout(() => {
			tickSlider();
		}, 100);
	});
	setTimeout(() => {
		tickSlider();
	}, 100);
})();
